import { createAsyncThunk } from "@reduxjs/toolkit";

import { IFactoringProfile, IPaymentSpeed } from "models/HaulPay";
import {
  IInvitedGroup,
  IInviteInformation,
  UserAccount,
  UserPermission,
  UserProfileFormData
} from "models/User";
import {
  createFactoringUserAPI,
  getInvitedCarrierPaymentTermsAPI,
  updateFactoringInfoAPI,
  updateFactoringProfileAPI
} from "services/api/joinHaulpay";
import {
  confirmInvitationAPI,
  getAccountAPI,
  getInvitedGroupsAPI,
  getUserPermissionAPI,
  updateUserEmailAPI,
  updateUserProfileAPI
} from "services/api/user";
import { getFactoringUserProfileAPI } from "services/api/haulpay";

export const getAccount = createAsyncThunk<UserAccount, string>(
  "loader/user/getAccount",
  async (userId: string, { rejectWithValue }) => {
    try {
      const { data } = await getAccountAPI(userId);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const getUserPermission = createAsyncThunk<UserPermission, string>(
  "loader/user/getUserPermission",
  async (userId: string, { rejectWithValue }) => {
    try {
      const { data } = await getUserPermissionAPI(userId);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const createFactoringUser = createAsyncThunk<any, { formData: any }>(
  "loader/user/createFactoringUser",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const { data } = await createFactoringUserAPI(formData);
      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const updateFactoringInfo = createAsyncThunk<
  UserAccount,
  { formData: any; factoring_id: string }
>("loader/user/updateFactoringInfo", async ({ formData, factoring_id }, { rejectWithValue }) => {
  try {
    const { data } = await updateFactoringInfoAPI(formData, factoring_id);

    return data;
  } catch (error: any) {
    if (error.response.data) return rejectWithValue(error.response.data);
  }
});

// Profile
export const updateUserProfile = createAsyncThunk<
  UserAccount,
  { userId: string; type: string } & UserProfileFormData
>("loader/user/updateUserProfile", async ({ userId, type, ...params }, { rejectWithValue }) => {
  try {
    const { data } = await updateUserProfileAPI(userId, type, params);

    return data;
  } catch (error: any) {
    if (error.response.data) return rejectWithValue(error.response.data);
  }
});

// Update user email
export const updateUserEmail = createAsyncThunk<UserAccount, { userId: string; email: string }>(
  "loader/user/updateUserEmail",
  async ({ userId, email }, { rejectWithValue }) => {
    try {
      const { data } = await updateUserEmailAPI(userId, email);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const getICOnboardingInformation = createAsyncThunk<IInviteInformation, string>(
  "loader/user/onboardingInformation",
  async (invited_token, { rejectWithValue }) => {
    try {
      const { data } = await confirmInvitationAPI(invited_token);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const getPaymentTerms = createAsyncThunk<IPaymentSpeed[], string>(
  "user/paymentTerms",
  async (factoring_id, { rejectWithValue }) => {
    try {
      const { data } = await getInvitedCarrierPaymentTermsAPI(factoring_id);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const getFactoringProfile = createAsyncThunk<IFactoringProfile, string>(
  "loader/user/factoringProfile",
  async (_factoring_id, { rejectWithValue }) => {
    try {
      const { data } = await getFactoringUserProfileAPI();

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const updateFactoringProfile = createAsyncThunk<IFactoringProfile, any>(
  "loader/user/updateFactoringProfile",
  async ({ factoring_id, params }, { rejectWithValue }) => {
    try {
      const { data } = await updateFactoringProfileAPI(factoring_id, params);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const getInvitedGroups = createAsyncThunk<IInvitedGroup[], "connected" | "pending">(
  "loader/user/getInvitedGroups",
  async (status, { rejectWithValue }) => {
    try {
      const { data } = await getInvitedGroupsAPI(status);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);
